import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_chunk } from '@shared/dto/grid2d_chunk/DTO__grid2d_chunk';
import { FN_SLICE__grid2d_recreate } from '../_methods/FN_SLICE__grid2d_recreate';
import { STATE__grid2d } from '../STATE__grid2d';

export const local_grid2d_chunk_upsert = (payload: DTO__grid2d_chunk[]): PayloadAction<DTO__grid2d_chunk[]> => ({
  type: ENUM__redux_action.GRID2D_CHUNK_UPSERT,
  payload,
});

export const init_local_grid2d_chunk_upsert = (state: STATE__grid2d, action: PayloadAction<DTO__grid2d_chunk[]>) => {
  let items = action.payload;

  if (items.is_empty()) return;

  for (let item of items) {
    item = item.clone();

    let grid2d = state.grids2d_map.get(item.grid2d_id);
    try_upsert_chunk_to_grid2d(grid2d, item);

    if (item.are_cells_loaded_first_time) {
      state.grid2d_loading_in_progress.delete(item._id);
      //need to force rerender
      state.grid2d_loading_in_progress = new Set(state.grid2d_loading_in_progress);
    }
  }

  //refresh map to trigger re-render
  FN_SLICE__grid2d_recreate(state);
};

function try_upsert_chunk_to_grid2d(grid2d: DTO__grid2d | undefined, grid2d_chunk: DTO__grid2d_chunk) {
  if (!grid2d) return;

  grid2d.chunk__upsert(grid2d_chunk);
}
